<template>
  <div class="pageContol studentList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">考试管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">重考审核</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="operationControl flexdc" style="align-items: flex-start">
          <div class="searchbox">
            <div title="姓名" class="searchboxItem ci-full">
              <span class="itemLabel">姓名:</span>
              <el-input v-model="retrievalData.fullName" type="text" size="small" placeholder="姓名" clearable />
            </div>
            <div title="身份证号" class="searchboxItem ci-full">
              <span class="itemLabel">身份证号:</span>
              <el-input v-model="retrievalData.idCard" type="text" size="small" placeholder="身份证号" clearable />
            </div>
            <div title="审核状态" class="searchboxItem ci-full">
              <span class="itemLabel">审核状态:</span>
              <el-select clearable size="small" v-model="retrievalData.auditState" placeholder="请选择">
                <el-option v-for="item in auditStateList" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
            <el-button type="primary" class="bgc-bv" round @click="getData()">查询</el-button>
          </div>
        </div>
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-table ref="multipleTable" :data="tableData" :height="tableHeight" size="small" tooltip-effect="dark"
              :header-cell-style="tableHeader" stripe>
              <el-table-column label="序号" align="center" type="index" :index="indexMethod" />
              <el-table-column label="考试日期" align="left" show-overflow-tooltip prop="examinationDate" minWidth="100" />
              <el-table-column label="作业类别" align="left" show-overflow-tooltip prop="workCategory" minWidth="100">
                <template slot-scope="scope">
                  {{ scope.row.workCategory ? $setDictionary("PA_WORK_CATEGORY", scope.row.workCategory) : "" }}
                </template>
              </el-table-column>
              <el-table-column label="申报考生" align="left" show-overflow-tooltip prop="fullName" minWidth="100" />
              <el-table-column label="考生身份证号" align="left" show-overflow-tooltip prop="idCard" minWidth="100" />
              <el-table-column label="审核状态" align="left" show-overflow-tooltip prop="auditState" minWidth="100">
                <template slot-scope="scope">
                  {{ scope.row.auditState ? $setDictionary("PA_RESIT_APPLY_STATE", scope.row.auditState) : "" }}
                </template>
              </el-table-column>
              <el-table-column label="申请时间" align="left" show-overflow-tooltip prop="applyTime" minWidth="100" />
              <el-table-column label="驳回原因" align="left" show-overflow-tooltip prop="auditDesc" minWidth="100" />
              <el-table-column label="操作" align="center" width="140px" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" style="padding: 0px 5px" size="mini" @click="goReexaminationReviewInfo(scope.row)" :disabled="['30','40'].includes(scope.row.auditState)">审核</el-button>
                </template>
              </el-table-column>
              <Empty slot="empty" />
            </el-table>
          </div>
        </div>
        <PageNum :apiData="apiData" @sizeChange="sizeChange" @getData="getData" />
      </div>
    </div>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
import { resetKeepAlive } from "@/utils/common";
export default {
  name: "examinationAffairsManage_reexaminationReview",
  components: {
    Empty,
    PageNum,
  },
  mixins: [List],
  data() {
    return {
      // 检索数据
      retrievalData: {
        fullName: "", // 姓名
        idCard: "", // 身份证号
        auditState: "", // 审核状态
      },
      auditStateList: [], // 审核状态 - 下拉数据
    };
  },
  created() {
    this.getDictionary();
  },
  watch: {},
  computed: {},
  mounted() { },
  methods: {
    // 获取 - 字典
    getDictionary() {
      // 审核状态
      let auditState = this.$setDictionary("PA_RESIT_APPLY_STATE", "list");
      for (const key in auditState) {
        if(key != '10'){
          this.auditStateList.push({
            value: key,
            label: auditState[key],
          });
        }
      }
    },
    // 获取 - 列表数据
    getData(pageNum = 1) {
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
        ...this.retrievalData
      };
      this.doFetch({
        url: "/biz/plan/resit/apply/audit/pageList",
        params,
        pageNum,
      }, true, 10);
    },
    // 去审核
    goReexaminationReviewInfo(item) {
      this.$router.push({
        path: "/practicalAssessmentSystem/examinationAffairsManage/reexaminationReviewInfo",
        query: {
          applyId: item.applyId, // 重考申请id
        },
      });
    },
  },
  beforeRouteLeave: resetKeepAlive,
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      if (from.path == '/practicalAssessmentSystem/examinationAffairsManage/reexaminationReviewInfo') {
        vm.getData(vm.pageNum)
      }
    })
  }
};
</script>
<style lang="less" scoped>
</style>